import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const SignUp = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const { name, phone, email } = formData;

    if (name.trim().length < 3) {
      toast.error("Name must be at least 3 characters long.");
      return false;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Phone must be a 10-digit number.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email.");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/users/getregister`, formData); // Update with actual API endpoint
      if (response?.data?.data) {
        toast.success("Registered successfully!");
        setFormData({
          name: "",
          phone: "",
          email: "",
        })
        navigate("/login")
        return
      }
      toast.error("Something went wrong.");
      return
    } catch (error) {
      toast.error(error.response?.data?.message || "Registration failed.");
      return
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: 'url("/Group.png")',
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 450,
          width: "100%",
          borderRadius: 3,
          boxShadow: 10,
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ mb: 1, fontSize: { xs: "1.8rem", sm: "2.2rem" } }}
          >
            Welcome!
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "#7A28CB",
              mb: 3,
              fontSize: { xs: "1.2rem", sm: "1.4rem" },
            }}
          >
            SignUp with
          </Typography>

          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
            sx={{ mb: 3 }}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              background: "linear-gradient(to right, #8e2de2, #4a00e0)",
              py: 1.5,
              fontWeight: "bold",
              fontSize: "1rem",
              textTransform: "none",
              "&:hover": {
                background: "linear-gradient(to right, #7a2bd2, #3a00c0)",
              },
            }}
            onClick={handleSubmit}
          >
            SIGNUP
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SignUp;
